import Vue from 'vue'
import VueI18n from 'vue-i18n'
import VueMeta from 'vue-meta'
import PortalVue from 'portal-vue'
import { App, plugin } from '@inertiajs/inertia-vue'
import { InertiaProgress } from '@inertiajs/progress/src'
import { BootstrapVue } from 'bootstrap-vue'
import VueSweetalert2 from 'vue-sweetalert2'
import fullscreen from 'vue-fullscreen'
import AppDirectives from '@/Library/directives';
import PageTitle from '@/Shared/PageTitle';
import mixinComponent from '@/Mixins/mixins'
import VueHtmlToPaper from 'vue-html-to-paper';

Vue.config.productionTip = false
Vue.mixin({ methods: { route: window.route } })
Vue.use(plugin)
Vue.use(PortalVue)
Vue.use(VueMeta)
Vue.use(VueSweetalert2)
Vue.use(VueI18n)
Vue.use(fullscreen)
Vue.use(AppDirectives)
Vue.use(BootstrapVue)
Vue.use(VueHtmlToPaper)

Vue.component('PageTitle', PageTitle);

Vue.mixin(mixinComponent);

InertiaProgress.init({ color: '#dc3545', includeCSS: true, showSpinner: true, })

const el = document.getElementById('app')
const lang = document.documentElement.lang.substr(0, 2);

const i18n = new VueI18n({
  locale: lang,
  messages: window.vuei18nLocales,
});

new Vue({
  i18n,
  metaInfo: {
    titleTemplate: title => (title ? `${title} - ${i18n.t('front.app_name')}` : i18n.t('front.app_name')),
  },
  render: h =>
    h(App, {
      props: {
        initialPage: JSON.parse(el.dataset.page),
        resolveComponent: name => import(`@/Pages/${name}`).then(module => module.default),
      },
    }),
}).$mount(el)
